import { render, staticRenderFns } from "./ArticleIndex.vue?vue&type=template&id=00520ba3&"
import script from "./ArticleIndex.vue?vue&type=script&lang=js&"
export * from "./ArticleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports